import { render, staticRenderFns } from "./GM-&-PEX-Command-Equivalents.md?vue&type=template&id=9b5222d4&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports